import BigNumber from "bignumber.js";

export interface Market {
  iv: BigNumber;
  disabled: boolean;
}

export class OptionMarket {
  markets: { [expiry: number]: { [strike: string]: { [isCall: string]: { [isBuy: string]: Market } } } } = {};
  // mapping(uint => bool) public disabledExpiries;
  // bool public tradeDisabled;

  callAdjust = new BigNumber(1);
  putAdjust = new BigNumber(1);

  getIv(expiry: number, strike: BigNumber, isCall: boolean, isBuy: boolean) {
    let adjust = isCall ? this.callAdjust : this.putAdjust;
    return (this.markets[expiry]?.[strike.toString(10)]?.[isCall.toString()]?.[isBuy.toString()]?.iv || new BigNumber(0)).times(adjust);
  }

  setIv(expiry: number, strike: BigNumber, isCall: boolean, isBuy: boolean, iv: BigNumber) {
    if (!this.markets[expiry]) {
      this.markets[expiry] = {};
    }
    if (!this.markets[expiry][strike.toString(10)]) {
      this.markets[expiry][strike.toString(10)] = {};
    }
    if (!this.markets[expiry][strike.toString(10)][isCall.toString()]) {
      this.markets[expiry][strike.toString(10)][isCall.toString()] = {};
    }
    if (!this.markets[expiry][strike.toString(10)][isCall.toString()][isBuy.toString()]) {
      this.markets[expiry][strike.toString(10)][isCall.toString()][isBuy.toString()] = {
        iv: new BigNumber(0),
        disabled: false
      };
    }
    this.markets[expiry][strike.toString(10)][isCall.toString()][isBuy.toString()].iv = iv;
  }
}
